import React from 'react';
import LandingPage from '../components/LandingPage';

export default function BanffDiningGuide() {
  return (
    <LandingPage
      testid="banff-dining-guide-page"
      slug="banff-dining-guide"
      title="The Banff Dining Guide: Where to Eat in the Rockies"
      metaTitle="Banff Dining Guide — Best Restaurants & Where to Eat in Banff | Culinera"
      metaDescription="Where to eat in Banff: mountaintop fine dining, Bear Street favourites, après-ski ramen, and the best restaurants in Banff National Park. Plan a free Banff & Bow Valley food itinerary with Culinera."
      heroImage="banff-dining-guide.jpg"
      heroAlt="Lively Banff Avenue street scene with outdoor cafes and snow-capped Rocky Mountain peaks behind the town"
      kicker="Banff Food Guide"
      wizardCity="Banff"
      wizardCuisines={['Fine Dining', 'Farm-to-Table']}
      picksHeading="Where to eat in Banff & the Bow Valley"
      restaurantIds={[
        'sky-bistro', 'eden-rimrock', 'the-bison', 'three-ravens', 'park-distillery',
        'chukos', 'lupo', 'block-kitchen', 'post-hotel', 'walliser-stube',
        'the-trough', 'crazyweed',
      ]}
      ctaHeading="Plan your Banff food trip"
      ctaText="Turn these mountain restaurants into a day-by-day Bow Valley food itinerary — from a gondola dinner above Banff to a Canmore chef's table."
      intro={[
        "Eating in Banff is unlike eating anywhere else in Canada: the dining rooms come with two-thousand-metre mountain views, the menus lean hard on Alberta beef and Rocky Mountain game, and the whole town sits inside a national park. This **Banff dining guide** covers the rooms worth planning a trip around — plus the Canmore and Lake Louise tables just down the highway.",
        "For the bucket-list meal, **Sky Bistro** sits atop Sulphur Mountain — you take a gondola up to dinner — while **Eden at The Rimrock** runs classical European tasting menus and one of Canada's deepest wine cellars. On Bear Street, The Bison plates rustic-modern Rocky Mountain cuisine, and Three Ravens at the Banff Centre frames Mount Rundle through the windows.",
        "For something more casual, Park Distillery pairs campfire-style rotisserie with grain-to-glass spirits, Chuko's slings après-ski ramen, and Lupo handles handmade pasta. Fifteen minutes east, **Canmore** is the chef's town — The Trough's intimate thirty-seat room and Crazyweed Kitchen's eclectic open kitchen are worth the short drive. North toward **Lake Louise**, the Post Hotel and the Fairmont's Walliser Stube fondue room round out the corridor.",
        "Below are the **best restaurants in Banff** and the Bow Valley — real, operating mountain rooms. Tap any for details and reservations advice, then build the whole route into a food itinerary.",
      ]}
      faqs={[
        {
          q: 'Where is the best place to eat in Banff?',
          a: 'For a special-occasion meal, Sky Bistro (atop Sulphur Mountain via gondola) and Eden at The Rimrock are the headline rooms. The Bison on Bear Street is the go-to for Rocky Mountain cuisine in a more relaxed setting.',
        },
        {
          q: 'Should I eat in Banff or Canmore?',
          a: 'Banff is the white-tablecloth, special-occasion town inside the national park; Canmore is the chef-owned, slightly better-value town fifteen minutes east. With two or more mountain meals, base in Canmore and do one Banff splurge.',
        },
        {
          q: 'Do you need reservations for Banff restaurants?',
          a: 'Yes — book the fine-dining rooms (Sky Bistro, Eden, Post Hotel) well ahead, especially in summer and ski season. The Trough in Canmore fills three weeks out.',
        },
      ]}
    />
  );
}
